import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Ignore removeChild errors caused by external scripts/extensions
    if (error?.message?.includes('removeChild') || error?.message?.includes('insertBefore')) {
      this.setState({ hasError: false });
      return;
    }
    console.error('App Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 text-center">
          <p className="text-gray-600 mb-4">Une erreur est survenue.</p>
          <button onClick={() => { this.setState({ hasError: false }); window.location.reload(); }} className="px-4 py-2 bg-blue-600 text-white rounded">
            Recharger la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
